import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import AsyncSelect from 'react-select/async';

import {
    ClearIndicator,
    Container,
    Control,
    customStyles,
    DropdownIndicator,
    Menu,
    MenuList,
    Option,
    OptionLinked,
    SmallOption,
} from '../dropdown';

const Select = ({ width, tag, selectRef, components, asyncMode, isSearchable, isLinked, smallOption, dataTest, ...rest }) => {
    const SelectComponent = asyncMode ? AsyncSelect : ReactSelect;

  const SelectOption = isLinked
    ? OptionLinked
    : smallOption
        ? SmallOption
        : Option;

    return (
        <Container as={tag} width={width} isSearchable={isSearchable} data-test={dataTest} id='id-1'>
            <SelectComponent
                ref={selectRef}
                isSearchable={isSearchable}
                styles={customStyles}
                components={{
                    IndicatorSeparator: null,
                    Control,
                    Option: SelectOption,
                    Menu,
                    MenuList,
                    DropdownIndicator,
                    ClearIndicator,
                    ...components,
                }}
                {...rest}
            />
        </Container>
    );
};

Select.propTypes = {
    width: PropTypes.string,
    components: PropTypes.object,
    asyncMode: PropTypes.bool,
    isSearchable: PropTypes.bool,
    smallOption: PropTypes.bool,
};

Select.defaultProps = {
    isSearchable: false,
};

export default Select;
